<template>
  <a :href="url" :class="['content-action', themeButtonComp, roundedComp]" v-openmodal="modalParams" :target="target">
    <div class="ico">
      <slot name="icon"></slot>
    </div>
    <span>
      <slot name="text"></slot>
    </span>
  </a>
</template>

<script>
export default {
  name: 'content-action',
  props: {
    modalParams: {
      type: Object,
      default: null
    },
    url: {
      type: String,
      default: '/'
    },
    target: {
      type: String,
      default: '_self'
    },
    theme: {
      type: String,
      default: 'green-primary'
    },
    horizontalAlign: {
      type: String,
      default: 'center'
    },
    rounded: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    hAlignComp() {
      return `content-action--${this.horizontalAlign}`
    },
    roundedComp() {
      return `content-action--rounded-${this.rounded}`
    },
    themeButtonComp() {
      return `content-action--${this.theme}`
    }
  }
}
</script>

<style lang="scss" scoped>
.content-action {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  padding: 0.8em 1.6em;
  font-size: 1.2em;
  line-height: 1em;
  font-weight: 500;
  letter-spacing: -1px;
  text-align: center;
  transition: all 0.35s ease;
  text-decoration: none;
  margin: 10px;
  float: left;

  &:hover {
    cursor: pointer;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }

  & .ico {
    display: flex;
    
    & img {
      max-width: 18px;
      height: auto;
      margin-right: 6px;
    }
  }

  // & .ico {
  //   display: flex;
  //   width: 24px;
  //   height: 24px;
  //   align-items: center;
  //   justify-content: center;

  //   & > img {
  //     max-width: 18px;
  //     height: auto;
  //     margin-right: 6px;
  //   }
  // }

  &--rounded-small {
    border-radius: 4px;
  }

  &--rounded-medium {
    border-radius: 40px;
  }

  &--rounded-large {
    padding: 0.8em;
    border-radius: 100%;

    & span {
      display: none;
    }

    & .ico > img {
      height: 24px;
      max-width: 24px;
      margin-right: 0;
    }
  }

  &--green-primary {
    color: #1d2822;
    background-color: #9ddda9;
  }

  &--green-secondary {
    color: #1d2822;
    background-color: #C9D88E;
  }

  &--black {
    color: #FFF;
    background-color: #000;
  }

  &--white {
    color: #000;
    background-color: #FFF;
  }
}
</style>